import { InterpolationWithTheme } from "@emotion/core";
const mqMobile = "@media only screen and (max-width: 768px)";
export const interventionsSummaryStyles: { [key: string]: InterpolationWithTheme<any> } = {
    summaryCardWrapper: {
        margin: 24,
        [mqMobile]: {
            margin: "24px 0px"
        }
    },
    summaryContainer: {
        padding: '18px 20px',
        minHeight: 300,
        [mqMobile]: {
            padding: 0
        }
    },
    kpiContainer: {
        display: "flex",
        justifyContent: "space-around",
        textAlign: "center",
        flexWrap: "wrap"
    },
    chartsContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        textAlign: "center",
        marginTop: 20
    },
    cardHeaderText: {
        color: "rgb(51, 51, 51)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        fontWeight: 500,
        marginBottom: 15,
        [mqMobile]: {
            color: "rgb(0, 0, 0)",
            textTransform: "uppercase",
            padding: "20px 20px 0px",
        }
    },
    seperator: {
        height: 1,
        background: "#b6c7d6",
        margin: "10px 0px 20px",
        [mqMobile]: {
            margin: "10px 0px 20px",
            borderTop: "1px solid #DCE5ED",
            height: 0
        }
    },
    timeRangeContainer: {
        margin: "10px 0px"
    },
    timeSelectorButton: {
        background: "transparent",
        marginRight: 10,
        border: "none",
        color: "rgb(128, 128, 128)",
        fontFamily: " BrandonTextWeb-Medium",
        fontSize: 13,
        fontWeight: 500,
        padding: "5px 17.5px",
        borderRadius: "10px"
    },
    timeSelectorButtonSelected: {
        background: "rgb(241, 245, 248)",
        color: "#ff316d",
        marginRight: 10,
        border: "none",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: 13,
        fontWeight: "bold",
        padding: "5px 17px",
        borderRadius: "10px"
    },
    chartWithLegend: {
        display: "flex"
    },
    legendContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: 'flex-start',
        color: "rgb(51, 51, 51)",
        fontFamily: " BrandonTextWeb-Medium",
        fontSize: 18,
        fontWeight: 500,
        marginLeft: -25
    },
    buttonText: {
        color: "rgb(128, 128, 128)",
        fontFamily: " BrandonTextWeb-Medium",
        fontSize: 13,
        fontWeight: 500
    },
    kpiBoldText: {
        color: "rgb(51, 51, 51)",
        fontFamily: " BrandonTextWeb-Bold",
        fontSize: 24,
        fontWeight: "bold"
    },
    kpiSmallText: {
        color: "rgb(51, 51, 51)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 12,
        fontWeight: 500
    },
    percentText: {
        color: "rgb(51, 51, 51)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: 20,
        fontWeight: "bold",
        position: "relative",
        right: 57,
        top: 27,
    },
    //mobile designs
    categoryContainer: {
        display: "flex",
        justifyContent: "space-between",
        fontFamily: "BrandonTextWeb-Medium",
        marginBottom: 18
    },
    summaryProgressContainer: {
        marginTop: 25,
        [mqMobile]: {
            marginTop: 0,
            padding: "20px 20px 0"
        }
    },
    categoryName: {
        fontSize: 18,
        color: "#333333"
    },
    categoryProgress: {
        fontSize: 15,
        color: "#000000"
    },
    progressBarWrapper: {
        display: "flex",
        justifyContent: "space-between",
    },
    percentComplete: {
        fontSize: 20,
        color: "rgb(51, 51, 51)",
        fontFamily: "BrandonTextWeb-Bold",
        position: "relative",
        top: "-10px"
    },
    wrapperCard: {
        borderRadius: 10,
        overflow: 'hidden',
        //padding: '18px 20px'
    }
}